import { render, staticRenderFns } from "./RichTextImg.vue?vue&type=template&id=371588e3&scoped=true"
import script from "./RichTextImg.vue?vue&type=script&lang=js"
export * from "./RichTextImg.vue?vue&type=script&lang=js"
import style0 from "./RichTextImg.vue?vue&type=style&index=0&id=371588e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371588e3",
  null
  
)

export default component.exports